import * as types from "@/store/constants/types";
export default {
  [types.UPDATE_SUPER_PAY_APP_CONFIG](state: any, payLoad: any) {
    state.superPayAppConfig = payLoad;
  },
  [types.UPDATE_SUPER_PAY_APP_CONFIG_INTERFACE_ENABLE](
    state: any,
    payLoad: any
  ) {
    state.superPayConfigInterfaceEnable = payLoad;
  },
  [types.UPDATE_SUPER_PAY_APP_INSTALLED_STATUS](state: any, payLoad: any) {
    state.superPayAppInstalled = payLoad;
  },
  [types.UPDATE_SUPER_PAY_WAY_INTERFACE_ENABLE](state: any, payLoad: any) {
    state.superPayWayInterfaceEnable = payLoad;
  },
  [types.UPDATE_SUPER_PAY_SHOW_ENABLE](state: any, payLoad: any) {
    state.superPayShowEnable = payLoad;
  }
};
